// extracted by mini-css-extract-plugin
module.exports = {"container":"Forbidden_container__2ugNv","content":"Forbidden_content__ES51O","title":"Forbidden_title__15kFb"};